import './styles.scss'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { resource } from 'api'
import { Button } from 'components/Form'
import ModalWrapper from 'components/ModalWrapper'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { FILE_MAX_SIZE_CONVERSATION } from 'constants/filesMaxSize'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const SelectFile = ({ user, iconName, title, accept, onChange }) => {
  const { companies: company } = useSelector(store => store)
  const [isOpenInfoModal, setIsOpenInfoModal] = useState(false)
  const [infoModalValue, setInfoModalValue] = useState('')
  const [fileUploading, setFileUploading] = useState(false)

  const toggleInfoModal = () => setIsOpenInfoModal(!isOpenInfoModal)

  const onUploadFiles = async ({ file }) => {
    setFileUploading(true)

    try {
      const formData = new FormData()
      const dataBody = {
        companyType: company.type,
        typeUpload: 'userFile'
      }
      user ? dataBody.user = user : dataBody.companyToken = company.hash

      formData.append('data', JSON.stringify(dataBody))
      formData.append('files', file)

      const { data } = await resource.uploadFiles(formData)

      if (typeof onChange === 'function') onChange(data.attachments)
    } catch (error) {
      console.error(error)
    }

    setFileUploading(false)
  }

  const readFile = async (file) => {
    return new Promise(resolve => {
      const reader = new FileReader()
      reader.readAsText(file)
      reader.onload = () => resolve(reader.result)
    })
  }

  const uploadFile = async (file) => {
    if (file.type.split('/')[0] !== accept.split('/')[0]) {
      setInfoModalValue(lang('dashboard_format-type-not-supported'))
      toggleInfoModal()
      return
    }

    let parsedFile = {
      name: file.name,
      size: file.size,
      preview: file.preview,
      lastModified: file.lastModified,
      file
    }

    if (FILE_MAX_SIZE_CONVERSATION > 0 && parsedFile.size > FILE_MAX_SIZE_CONVERSATION) {
      setInfoModalValue(lang('file-too-big'))
      toggleInfoModal()
    } else {
      const filePreview = await readFile(file)
      parsedFile.preview = filePreview
      onUploadFiles(parsedFile)
    }
  }

  const handleFile = () => {
    let input = document.createElement('input')
    input.type = 'file'
    input.accept = accept || ''
    input.onchange = () => uploadFile(input.files[0])
    input.click()
  }

  return (
    <div className='select-file'>
      <button className='select-file__btn' onClick={handleFile}>
        {fileUploading ? (
          <Nixi1Spinner width='15px' height='15px' />
        ) : (
          <figure>
            <img src={getStaticImage(`/icons/orange-brand/${iconName}.svg`)} alt={title} />
          </figure>
        )}
        <span className='text-ellipsis'>{title}</span>
      </button>

      <ModalWrapper
        isOpen={isOpenInfoModal}
        toggle={toggleInfoModal}
        body={
          <p className='select-file__modal-info'>{infoModalValue}</p>
        }
        footer={
          <div className='select-file__modal-footer'>
            <Button secondary value='OK' onClick={toggleInfoModal} />
          </div>
        }
      />
    </div>
  )
}

export default SelectFile
